<template>
  <paper class="key_data">
    <el-radio-group
      v-model="classify"
      @change="selectClassify"
      class="header_radio"
    >
      <el-radio :label="AllSUPPLIERS"></el-radio>
      <el-radio :label="PENDINGSUPPLIERS"></el-radio>
    </el-radio-group>
    <m-pane
      v-if="tableShow"
      v-show="allSupplier"
      ref="tablePage"
      :config="config"
      :totalData="totalData"
      :pageTotal="pageTotal"
      :loading="false"
      :searchTotalTitle="config.searchTotalTitle"
      :currentPage="currentPage"
      :initSearchInfo="initSearchInfo"
      searchId="keyData"
      pageID="keyDataList251031"
      @edit-btn="editBtn"
      @row-db-click="rowDBclick"
      @selectChange="selectChange"
      @searchChange="searchChange"
      @pageChange="pageChange"
      @sizeChange="sizeChange"
    >
      <div slot="table-module-btn" class="btn-box">
        <el-tooltip
          effect="dark"
          content="新增"
          placement="bottom"
          style="margin-left: 10px"
        >
          <el-button
            class="bigData-btn-add"
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="handleAdd"
            v-has="'04000026'"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="导出"
          placement="bottom"
          style="margin-left: 10px"
        >
          <el-button
            class="bigData-btn-export"
            icon="el-icon-download"
            size="mini"
            :loading="exportLoading"
            @click="handleExport"
            v-has="'04000027'"
          ></el-button>
        </el-tooltip>
      </div>
      <div slot="btn-content" class="btn_content">
        <el-button
          class="btn bigData-btn-new"
          type="text"
          :loading="nsLoading"
          @click="newService"
          v-has="'04000023'"
          >新服务申请</el-button
        >
        <el-button
          class="btn bigData-btn-quit"
          type="text"
          @click="handleQuit"
          v-has="'04000024'"
          >退出申请</el-button
        >
        <!-- <el-button type="text" class="btn" @click="handleSyncVisible">同步承运商资源池</el-button> -->
        <el-button
          class="btn bigData-btn-sync"
          type="text"
          :loading="syncLogisticsLoading"
          @click="handleSyncLogistics"
          >同步到大物流</el-button
        >
      </div>
        <div slot="page-module-btn">
            <el-button v-has="'/keyData-100'" class="bigData-btn-dt-export" type="primary" @click="handleDetailExport" >明细导出</el-button>
        </div>
    </m-pane>
    <await-supplier
      :classify="classify"
      :overseaSwitch="overseaSwitch"
      :tableShow="tableShow"
      v-show="!allSupplier"
      ref="tablePage_"
    ></await-supplier>
    <supplier-black-dialog
      :openBlackDialog="openBlackDialog"
      :row="row"
      :formData="blackFormData"
      @closeDialog="closeBlackDialog"
      @confirmDialog="confirmBlackDialog"
    >
    </supplier-black-dialog>
    <supplier-quit-dialog
      :openQuitDialog="openQuitDialog"
      :row="row"
      :formData="quitFormData"
      @closeDialog="closeQuitDialog"
      @confirmDialog="confirmQuitDialog"
    >
    </supplier-quit-dialog>
    <add-or-edit-dialog
      :openAddOrEditDialog="openAddOrEditDialog"
      :overseaSwitch="overseaSwitch"
      @closeDialog="closeAddOrEditDialog"
      @confirmDialog="confirmAddOrEditDialog"
    >
    </add-or-edit-dialog>
    <new-service-dialog
      :openNewServiceDialog="openNewServiceDialog"
      :row="row"
      @closeDialog="closeNewServiceDialog"
      @confirmDialog="confirmNewServiceDialog"
    >
    </new-service-dialog>
    <el-dialog
      title="同步类型"
      :visible.sync="syncVisible"
      :before-close="handleSyncClose"
    >
      <el-radio-group v-model="synchronizeType">
        <el-radio :label="1">同步联系人</el-radio>
        <el-radio :label="2">同步季度绩效kpi</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSyncClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="syncLoading"
          @click="handleSynChronize"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <detail-export-dialog ref="detailExport" />
    <md-immediate-evaluation
        ref="evaluateRef"
        :env="intimeevaluate.env"
        :lang="intimeevaluate.lang"
        :userInfo="intimeevaluate.userInfo"
        :templeteInfo="intimeevaluate.templeteInfo"
    />
  </paper>
</template>

<script>
import userEnvConfig from '@/config/user.env.js'
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { MdImmediateEvaluation } from 'intimeevaluate'
import awaitSupplier from './AwaitSupplier.vue';
import mPane from '../../../../components/Panel.vue';
import paper from '@/components/core/paper/Paper';
import config from './configAll.js';
import supplierBlackDialog from './SupplierBlackDialog.vue';
import supplierQuitDialog from './SupplierQuitDialog.vue';
import addOrEditDialog from './AddOrEditDialog.vue';
import newServiceDialog from './NewServiceDialog.vue';
import { dictWithUrl } from '@/components/lots/api';
import { getAllSupplierList, queryNewService, exportListData, queryQuitService,
    showQuitInfoService, showBlackInfoService, manualSyn, handworkSupplierDataSyncJob } from '../../../../api/register/supplierList.js';
import { getSysControlParamByCode } from '../../../../api/toDo/sysParamsConfig.js'
import { TRANSPORTATION, EXPRESS, COMPANY, OS_LGT } from '../../../../constant/constant.js';
import dayjs from 'dayjs';
import DetailExportDialog from './DetailExportDialog.vue';
const OPERATE_TYPE = ['1', '0']; // 1-退出,0-拉黑

const DICT_CODES = 'SYS_SUPPLIERS_TYPE,SYS_SUPPLIERS_STATUS,SYS_SUPPLIERS_PROPERTY,SRM_IS_OVERSEAS,SRM_BUSYNESS_TYPE_BACKGROUND,SRM_SHIPPER_TYPE,SRM_TRANSPORT_TYPE,SUPPLIER_SOURCE_ROUTE,' +
    'SU_CORPORATE_TYPE,SU_LEASE_TYPE,SRM_CHANGE_FLAG,SRM_BLACK_FLAG,SRM_SPECIAL_FLAG,SRM_QUALITY_FLAG,SRM_RECTIFICATION_TYPE,SYS_SUPPLIER_SERVICES_STATUS,SRM_YES_NO'

export default {
    name: 'keyData',
    components: { mPane, paper, supplierBlackDialog, supplierQuitDialog, addOrEditDialog, newServiceDialog, awaitSupplier, DetailExportDialog, MdImmediateEvaluation },
    data() {
        return {
            config,
            TRANSPORTATION,
            EXPRESS,
            AllSUPPLIERS: '全部供应商',
            PENDINGSUPPLIERS: '待处理供应商',
            dict: {},
            allSupplier: true,
            openAddOrEditDialog: false,
            openBlackDialog: false,
            openQuitDialog: false,
            openNewServiceDialog: false,
            exportLoading: false,
            row: {},
            classify: '全部供应商',
            selected: [],
            currentPage: 1,
            searchQuery: {},
            searchInitObj: {
                supplierCode: '',
                supplierNameCn: '',
                createTimeArr: ''
            },
            searchObj: {},
            pageTotal: 0,
            totalData: [],
            exportParams: {},
            quitFormData: null,
            blackFormData: null,
            initSearchInfo: this.$store.state.initSearchInfo,
            syncVisible: false, // 承运商资源池-同步弹窗展示
            synchronizeType: 1, // 承运商资源池-同步类型
            syncLoading: false, // 承运商资源池-同步确认加载状态
            syncLogisticsLoading: false, // 大物流-同步加载状态
            nsLoading: false, // 新服务申请加载状态
            isFromPA: false, // 是否从绩效调整跳转过来时执行
            overseaSwitch: true, // 涉外业务类型 显示开关
            tableShow: false,
        };
    },
    computed: {
        ...mapGetters(['currentTenant']),
        intimeevaluate() {
            return {
                env: userEnvConfig.env === 'PROD' ? 'prod' : 'sit', // 所在的当前环境：sit、uat、ver、prod
                lang:'zh-CN', //国际化语言：zh-CN | en-US | ja-JP
                userInfo: {
                    user_name: this.$store.state.user.userName, // mip账号（姓名）
                    user_id: this.$store.state.user.userCode // mip账号
                },
                templeteInfo: {
                    business: '安得智联', // 领域 eg: 内销领域
                    product: 'PRM合作伙伴关系管理', // 产品 eg: TPC交易与履约中心
                    system: 'C-LSRM', // 系统 eg: 美云销
                    scene: 'C-LSRM系统>>主数据管理>>供应商主数据', // 投放位置, 挂件式一般放页面右下角，eg: 人才搜索右侧
                    terminal: 'PC',
                }
            }
        },
    },
    methods: {
        load() {},
        editBtn(data) {},
        pageChange(data) {
            this.currentPage = data;
            if (this.allSupplier) {
                this.handleGetAllSupplierList();
            }
        },
        sizeChange(data) {
            this.config.page.pageSize = data;
            this.currentPage = 1;
            this.handleGetAllSupplierList();
        },
        searchChange(data) {
            // 如果常服务区域字段存在，就拆分下字段，省市字段分开传编码
            if (data.serviceAreaAddress && data.serviceAreaAddress.length > 0) {
                const serviceAreaAddress = JSON.parse(JSON.stringify(data.serviceAreaAddress));
                data.serviceProvinceCode = serviceAreaAddress[0];
                data.serviceCityCode = serviceAreaAddress[1];
                delete data.serviceAreaAddress;
            }
            this.currentPage = 1;
            this.handleGetAllSupplierList(data);
        },
        async handleGetAllSupplierList(searchQuery) {
            const searchParams = {};
            if (searchQuery) {
                this.searchQuery = searchQuery;
                this.$store.commit('setInitSearchInfo', searchQuery);
            }
            _.forIn(this.searchQuery, function(value, key) {
                if (value instanceof Array) {
                    searchParams[key] = value.join(',');
                } else {
                    searchParams[key] = value;
                }
            });
            let params = { pageNo: this.currentPage, pageSize: this.config.page.pageSize };
            // const res = await dictWithUrl('SRM_IN_OUT_LIMIT_TIME');
            // if (res.data['SRM_IN_OUT_LIMIT_TIME'].SRM_IN_OUT_LIMIT_FLAG === 'false') {
            //     if (searchParams.createTimeArr) {
            //         const startTime = searchParams.createTimeArr.split(',')[0];
            //         const endTime = searchParams.createTimeArr.split(',')[1];
            //         if ((new Date(endTime).getTime() - new Date(startTime).getTime()) > 2 * 7 * 24 * 3600 * 1000) {
            //             this.$message.warning('时间区间不能大于两周');
            //             return;
            //         };
            //         searchParams.createTimeArr = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') + ',' + dayjs(endTime).format('YYYY-MM-DD HH:mm:ss')
            //     } else {
            //         if (!searchParams.supplierCode && !searchParams.supplierNameCn) {
            //             this.$message.warning('供应商编码、供应商名称、时间不能同时为空');
            //             return;
            //         };
            //     }
            // } else {
            //     if (searchParams.createTimeArr) {
            //         const startTime = searchParams.createTimeArr.split(',')[0];
            //         const endTime = searchParams.createTimeArr.split(',')[1];
            //         searchParams.createTimeArr = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') + ',' + dayjs(endTime).format('YYYY-MM-DD HH:mm:ss');
            //     }
            // }
            if (searchParams.createTimeArr) {
                const startTime = searchParams.createTimeArr.split(',')[0];
                const endTime = searchParams.createTimeArr.split(',')[1];
                if (dayjs(endTime).subtract(1, 'month').subtract(1, 'day') > dayjs(startTime)) {
                    this.$message.warning('时间区间不能大于一个月');
                    return;
                };
                searchParams.createTimeArr = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') + ',' + dayjs(endTime).format('YYYY-MM-DD HH:mm:ss');
            } else if (searchParams.businessCreateTimeStr){
                const startTime = searchParams.businessCreateTimeStr.split(',')[0];
                const endTime = searchParams.businessCreateTimeStr.split(',')[1];
                if (dayjs(endTime).subtract(1, 'month').subtract(1, 'day') > dayjs(startTime)) {
                    this.$message.warning('业务类型创建时间区间不能大于一个月');
                    return;
                };
                searchParams.businessCreateTimeStr = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') + ',' + dayjs(endTime).format('YYYY-MM-DD HH:mm:ss');
            } else if (
                searchParams.propertyNature !== COMPANY &&
                searchParams.isOverseas !== OS_LGT &&
                !searchParams.supplierCode &&
                !searchParams.supplierNameCn &&
                !searchParams.supplierCodeGroup &&
                !searchParams.idCard &&
                !searchParams.idCard
            ) {
                // 主体性质不是法人且涉外业务类型不是海外业务时，供应商编码、供应商名称、集团编号、身份证号、时间、业务类型创建时间不能同时为空
                this.$message.warning('供应商编码、供应商名称、集团编号、身份证号、时间、业务类型创建时间不能同时为空');
                return;
            }
            // if (searchParams.createTimeArr) {
            //     const startTime = searchParams.createTimeArr.split(',')[0];
            //     const endTime = searchParams.createTimeArr.split(',')[1];
            //     searchParams.createTimeArr = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') + ',' + dayjs(endTime).format('YYYY-MM-DD HH:mm:ss');
            // }
            params = { ...params, ...searchParams };
            params.orderByType = 'desc';
            params.queryFlag = '0';
            this.exportParams = params;
            getAllSupplierList(params).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = this.formatData(res.data.list);
                    this.pageTotal = res.data.totalCount;
                    this.currentPage = res.data.pageNo;
                    this.$store.commit('setInitPageInfo', { currentPage: this.currentPage, pageSize: this.config.page.pageSize });
                }
            });
        },
        rowDBclick(row) {
            this.$router.push({
                path: '/keyData/detail',
                query: {
                    id: row.id || '',
                    businessType: row.businessType || '',
                    supplierCode: row.supplierCode || '',
                    businessTypeId: row.businessTypeId || '',
                    propertyNature: row.propertyNature || ''
                }
            });
        },
        selectChange(data) {
            this.selected = [].concat(data);
        },
        selectClassify() {},
        handleExport() {
            delete this.exportParams.pageNo;
            delete this.exportParams.pageSize;
            this.$confirm('是否确定导出?', '导出确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.exportLoading = true;
                exportListData(JSON.stringify(this.exportParams)).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data || '文件处理中，稍后请留意右上角文件中心下载文件！')
                    }
                }).finally(() => { this.exportLoading = false; });
            });
        },
        handleAdd() {
            this.openAddOrEditDialog = true;
        },
        /** 新服务申请 **/
        newService() {
            if (this.selected.length !== 1) {
                this.$message.warning('请选择一条数据进行操作');
            } else {
                const params = this.selected[0];
                params.tenantCode = this.currentTenant.tenantCode;
                this.nsLoading = true
                queryNewService(params).then(res => {
                    // res.data 为1，符合申请标准，为0，不符合申请标准
                    if (res && +res.code === 0 && +res.data === 1) {
                        this.row = this.selected[0];
                        this.openNewServiceDialog = true;
                    } else if (res && +res.code === 0 && +res.data === 0) {
                        this.$message.warning('该供应商不符合新服务申请标准，请核对');
                    }
                }).catch(err => {}).finally(() => { this.nsLoading = false });
            }
        },
        closeNewServiceDialog(data) {
            this.openNewServiceDialog = data;
        },
        confirmNewServiceDialog(data) {
            this.openNewServiceDialog = data;
        },
        /** 退出申请 **/
        handleQuit() {
            if (this.selected.length === 0 || this.selected.length > 1) {
                this.$message.warning('请选择一条数据进行操作');
            } else {
                const { supplierCode, supplierType, businessTypeId, businessType } = this.selected[0];
                queryQuitService({
                    supplierCode, supplierType, businessTypeId, businessType, tenantCode: this.currentTenant.tenantCode
                }).then(res => {
                    if (res && +res.code === 0 && res.data === 1) {
                        this.showQuitInfo(OPERATE_TYPE[0]);
                    }
                });
            }
        },
        showQuitInfo(type) {
            const { supplierCode, businessType } = this.selected[0];
            let infoId = null;
            const reqFunc = type === OPERATE_TYPE[0] ? showQuitInfoService : showBlackInfoService;
            const params = type === OPERATE_TYPE[0] ? { supplierCode, businessType, operateType: type } : { supplierCode, operateType: type };
            reqFunc(params).then(res => {
                if (res && +res.code === 0) {
                    if (type === OPERATE_TYPE[0]) {
                        this.openQuitDialog = true;
                        if (res.data) {
                            const { quitType, quitReason, memo, fileName, fileUrl, id } = res.data;
                            infoId = id;
                            this.quitFormData = { quitType, quitReason, memo, fileName, fileUrl, quitTip: '' };
                        }
                    } else {
                        this.openBlackDialog = true;
                        if (res.data) {
                            const { memo, fileName, fileUrl, id } = res.data;
                            infoId = id;
                            this.blackFormData = { memo, fileName, fileUrl };
                        }
                    }
                    this.row = { ...this.selected[0], id: infoId };
                }
            });
        },
        closeQuitDialog(data) {
            this.openQuitDialog = data;
            this.row = {};
        },
        confirmQuitDialog(data) {
            this.openQuitDialog = data;
        },
        closeBlackDialog(data) {
            this.openBlackDialog = data;
            this.row = {};
        },
        confirmBlackDialog(data) {
            this.openBlackDialog = data;
        },
        closeAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
        },
        confirmAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
        },
        formatData(data) {
            return data.map(item => {
                item.supplierStatus = this.dict.SYS_SUPPLIERS_STATUS[item.supplierStatus];
                item.propertyNature_ = this.dict.SYS_SUPPLIERS_PROPERTY[item.propertyNature];
                item.isOverseas_ = this.dict.SRM_IS_OVERSEAS[item.isOverseas];
                item.businessType_ = this.dict.SRM_BUSYNESS_TYPE_BACKGROUND[item.businessType];
                item.businessTypeStatus_ = this.dict.SYS_SUPPLIER_SERVICES_STATUS[item.businessTypeStatus];
                item.transType = this.dict.SRM_SHIPPER_TYPE[item.transType];
                item.corporateType = this.dict.SU_CORPORATE_TYPE[item.corporateType];
                item.transportType = this.dict.SRM_TRANSPORT_TYPE[item.transportType];
                item.lesseeType = this.dict.SU_LEASE_TYPE[item.lesseeType];
                item.updateFlag = this.dict.SRM_CHANGE_FLAG[item.updateFlag];
                item.blackFlag = this.dict.SRM_BLACK_FLAG[item.blackFlag];
                item.specialFlag = this.dict.SRM_SPECIAL_FLAG[item.specialFlag];
                item.qualityIsComplete = this.dict.SRM_QUALITY_FLAG[item.qualityIsComplete];
                item.rectifyFlag = this.dict.SRM_RECTIFICATION_TYPE[item.rectifyFlag];
                item.interimPaymentText = this.dict.SRM_YES_NO[item.interimPayment];
                //供应商来源途径 11：其他
                if(item.supplierSourceWay==='11'){
                    let specificSourceWay=item.specificSourceWay;
                    item._supplierSourceWay = `${this.dict.SUPPLIER_SOURCE_ROUTE[item.supplierSourceWay]}-${specificSourceWay===null?'':specificSourceWay}`;//供应商来源途径
                }else{
                    item._supplierSourceWay = this.dict.SUPPLIER_SOURCE_ROUTE[item.supplierSourceWay];//供应商来源途径
                }
                
                return item;
            });
        },
        async handleAllOrPending() {
            if (this.classify === this.AllSUPPLIERS) {
                this.allSupplier = true;
                // 从绩效调整跳转过来时不往下执行
                if (this.isFromPA) {
                    return false
                }
                const { currentPage, pageSize } = this.$store.state.initPageInfo;
                this.currentPage = currentPage;
                this.config.page.pageSize = pageSize;
                await this.initTime();
                this.initSearchInfo = Object.assign(this.initSearchInfo, this.searchInitObj);
                this.handleGetAllSupplierList(this.initSearchInfo);
                return;
            }
            if (this.classify === this.PENDINGSUPPLIERS) {
                this.allSupplier = false;
            }
        },
        initTime() {
            const startTime = dayjs().startOf('day').subtract(1, 'M').format('YYYY-MM-DD HH:mm:ss');
            const endTime = dayjs(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.searchInitObj.createTimeArr = startTime + ',' + endTime;
        },
        // 承运商资源池-同步弹窗展示
        handleSyncVisible() {
            if (this.selected.length) {
                this.syncVisible = true;
            } else {
                this.$message.warning('请勾选需要同步的数据!');
            }
        },
        // 承运商资源池-同步确认
        handleSynChronize() {
            const idList = this.selected.map(item => item.id);
            this.syncLoading = true;
            manualSyn({ idList, type: this.synchronizeType }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('同步成功!');
                    this.handleSyncClose();
                    this.handleGetAllSupplierList();
                }
            }).finally(() => { this.syncLoading = false; });
        },
        // 承运商资源池-同步弹窗关闭
        handleSyncClose() {
            this.syncVisible = false;
            this.synchronizeType = 1;
        },
        // 大物流-同步
        handleSyncLogistics() {
            this.syncLogisticsLoading = true;
            handworkSupplierDataSyncJob().then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('同步成功!');
                }
            }).finally(() => { this.syncLogisticsLoading = false; });
        },
        handleDetailExport() {
            this.$refs.detailExport.open();
        }
    },
    watch: {
        classify: {
            handler() {
                this.handleAllOrPending();
            }
        }
    },
    mounted() {
        getSysControlParamByCode({ controlCode: 'OVERSEA_SWITCH' }).then(res => {
            if (res && +res.code === 0 && res.data) {
                this.overseaSwitch = !!JSON.parse(res.data)
                const configTemp = JSON.parse(JSON.stringify(this.config))
                if (!this.overseaSwitch) {
                    configTemp.searchList.searchTxt = config.searchList.searchTxt.filter(item => item.value !== 'isOverseas')
                    configTemp.table.columns = config.table.columns.filter(item => item.prop !== 'isOverseas_')
                }
                this.config = configTemp
            }
        }).finally(() => {
            this.tableShow = true
        })
        // 从绩效调整跳转过来时不往下执行
        if (this.$route.query.from === 'performanceAdjustment') {
            return false
        }
        dictWithUrl(DICT_CODES).then(res => {
            this.dict = res.data;
            this.handleAllOrPending();
        });
        setTimeout(() => {
            this.$refs.evaluateRef && this.$refs.evaluateRef.openEvaluateModal()
        }, 5000)
    },
    activated() {
        // 从绩效调整跳转过来时执行
        if (this.$route.query.from === 'performanceAdjustment' && this.$route.query.supplierCode) {
            dictWithUrl(DICT_CODES).then(res => {
                this.isFromPA = true
                this.classify = this.AllSUPPLIERS
                this.allSupplier = true;
                this.currentPage = 1;
                const configTemp = JSON.parse(JSON.stringify(this.config))
                configTemp.searchList.searchTxt.forEach(item => {
                    if (item.value === 'createTimeArr') {
                        item.timeNum = null
                    }
                })
                this.config = configTemp
                this.config.page.pageSize = this.$store.state.initPageInfo.pageSize;
                this.initSearchInfo = { supplierCode: this.$route.query.supplierCode }
                this.dict = res.data;
                this.handleGetAllSupplierList(this.initSearchInfo);
            });
        }
    }
};
</script>

<style lang="less">
.key_data {
    margin: 7px;
    min-width: 1200px;

    #mPane3 .el-table {
        min-height: calc(100vh - 270px);
        max-height: calc(100vh - 270px);
    }

    .header_radio {
        width: 100%;
        height: 20px;
    }

    .btn_content {
        margin-bottom: 10px;
        width: 100%;
        height: 28px;
        font-size: 12px;
        background-color: #fffbf2;
        border: 1px solid #ffece3;
        box-sizing: border-box;
        line-height: 28px;

        .btn {
            cursor: pointer;
            margin-left: 20px;
            color: #666;
        }
    }

    .model-table-search .select-btn-box {
        width: auto;
    }
}
</style>
